import { useState } from 'react'
import { AnimatePresence } from 'framer-motion'
import { openModal } from 'service/modal-service'
import { AirconBooking } from './AirconBooking'
import { AirconItemSelection } from './AirconItemSelection'
import { Services } from '@/index/service/Services'
import { BottomButtons } from './BottomButtons'

export const GUIDE_BOOKING_ID = 'book'

/**
 * The aircon price card for a guide (/sg/aircon-servicing-singapore/[slug]),
 * rendered after the article rather than as its hero. Guides used to open
 * with the service-page hero - generic video, general-servicing prices, the
 * post title inside the card - which pushed the article below the fold on
 * mobile and offered prices unrelated to most guides. The page renders this
 * only for guides whose topic the card's prices actually cover (see
 * GUIDE_BOOKING_CLUSTERS in [slug].js), with the matching tab preselected.
 *
 * Booking is wired exactly as on the service pages: price tiles quick-book,
 * "More Options" opens the AirconItemSelection picker, never the wizard.
 */
export const AirconGuideBooking = ({
  requestCategorySettings,
  standardServicing,
  chemicalServicing,
  overhaulServicing,
  currencyCd,
  countryName,
  requestType,
  setIsShowJobScope,
  serviceType,
  setServiceType,
  setUnit,
  setUnitType,
  setCost,
  title,
}) => {
  const [requestForm, setRequestForm] = useState(false)
  const [isShowAirconItemSelection, setIsShowAirconItemSelection] = useState(false)
  const [isQuickBook, setIsQuickBook] = useState(false)
  const [isCustomBook, setIsCustomBook] = useState(false)

  const showJobScope = (serviceType, unitType, unit, cost) => {
      setServiceType(serviceType)
      setUnit(unit)
      setUnitType(unitType)
      setCost(cost)
      openModal(setIsShowJobScope)
  }

  const scrollToCard = () => {
      document.getElementById(GUIDE_BOOKING_ID)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <>
      {/* The card is styled to sit on a dark hero from sm up (bg-black/50, white text) */}
      <section id={GUIDE_BOOKING_ID} className='mb-10 bg-gray-100 sm:bg-gray-800 py-6 sm:py-10 scroll-mt-16'>
          <AirconBooking
              requestCategorySettings={requestCategorySettings}
              setRequestForm={setRequestForm}
              oneTimeServicing={standardServicing}
              chemicalServicing={chemicalServicing}
              overhaulServicing={overhaulServicing}
              setIsQuickBook={setIsQuickBook}
              setIsCustomBook={setIsCustomBook}
              currencyCd={currencyCd}
              countryName={countryName}
              showJobScope={showJobScope}
              serviceType={serviceType}
              setIsShowAirconItemSelection={setIsShowAirconItemSelection}
              title={title}
              headingAs='h2'
          />
      </section>
      {!requestForm &&
          <BottomButtons countryName={countryName} onBook={scrollToCard}/>
      }
      {requestForm &&
          <Services
            requestType={requestType}
            requestCategorySettings={requestCategorySettings}
            setRequestForm={setRequestForm}
            isQuickBook={isQuickBook}
            isCustomBook={isCustomBook}
            asSheet
          />
      }
      {isShowAirconItemSelection && (
          <AnimatePresence>
            <AirconItemSelection
                setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                setRequestForm={setRequestForm}
                setIsCustomBook={setIsCustomBook} setIsQuickBook={setIsQuickBook}
                userId={null}
            />
          </AnimatePresence>
      )}
    </>
  )
}
